export const XL = "1200px";
export const MD = "768px";
export const XL_NUM = +XL.replace(/\D/g, "");

export const HEIGHT_XL = "864px";
export const HEIGHT_XL_NUM = +HEIGHT_XL.replace(/\D/g, "");
